/**
 * 设置树选择中部门不可用状态TreeNode
*/
export const setDepartmentUnuse = (list) => {
    // 设置TreeNode不可选取状态
    const setStatus = (item) => {
        if (String(item.id).indexOf('P') !== -1) return item;
        item.disabled = true;
        item.selectable = false;
        item.checkable = false;

        return item;
    };

    const setListStatus = (list) => {
        list.forEach((item) => {
            item = setStatus(item);
        });
        return list;
    };

    const flatten = (flattenList) => {
        flattenList.forEach((item) => {
            item = setStatus(item);
            if (item.userList && item.userList.length > 0) item.userList = setListStatus(item.userList);

            if (item.children && item.children.length) flatten(item.children);
        });
    };

    flatten(list);

    return list;
};

/**
 * 兼容多选处理
 * @params {Array<string>} id List
 * @params {Array<string>} username List
 * @params {Array<string>} department List
*/
export const useStaffChoice = (id, username, department) => {
    let str = '';

    for (let index = 0; index < id.length; index += 1) {
        const pId = id[index];
        const pUsername = username[index];
        const pDepartment = department[index];
        str += `${pId},${pUsername},${pDepartment}#`;
    }

    return str.slice(0, str.length - 1);
};

/**
 * webSocket通知处理
 * @params {string} useStaffChoice str
 * @params {cb} cb(staffList)
*/
export const useStaffNotice = (str, cb) => {
    const staffStrList = str.split('#');
    const staffList = [];
    staffStrList.forEach((itemStr) => {
        staffList.push(itemStr.split(','));
    });
    if (cb) {
        staffList.forEach((staff) => {
            cb(staff);
        });
        return;
    }
    return staffList;
};

/**
 * 回显text通知人
*/
export const getTextNickName = (str) => {
    if (!str) return '';
    let nickName = '';

    if (str.indexOf('#') === -1) return str.split(',')[1];

    const staffStrList = str.split('#');
    staffStrList.forEach((itemStr) => {
        const [id, username] = itemStr.split(',');
        nickName += `${username}、`
    });
    if (!nickName) return str;

    return nickName.slice(0, nickName.length - 1);
};

/**
 * 回显组织架构+昵称
*/
export const getStructureNameAndNickName = (str) => {
    if (!str) return '';
    let newStr = '';

    if (str.indexOf('#') === -1) return `${str.split(',')[2]} ${str.split(',')[1]}`;

    const staffStrList = str.split('#');
    staffStrList.forEach((itemStr) => {
        const [id, username, structureName] = itemStr.split(',');
        newStr += `${structureName} ${username}、`
    });
    if (!newStr) return str;

    return newStr.slice(0, newStr.length - 1);
};
